// Legacy menus stored pageImages as public bucket URLs that 403 now — the
// bucket is private. Rewrite to the server proxy path. New menus already
// store /api/menu/:menuId/page/:idx; dev fallback is a data: URI.
export function resolvePageSrc(menuId: string, raw: string, idx: number): string {
  if (raw.startsWith('data:')) return raw;
  if (raw.startsWith('/api/')) return raw;
  return `/api/menu/${menuId}/page/${idx}`;
}
